"use client"
import { SpaceParcelOwnership } from "../../../plan-a/SpaceParcelOwnership"
import { useAnimationTuning } from "../../../animation/animationTuningContext"
import { useHudContext, useHudDates } from "../../shared/playbookHUDInfra"

// px the parcel rises from while fading in (and sinks back to on exit).
const PARCEL_ENTER_RISE_PX = 24

// Bottom-pinned space parcel panel. It stays MOUNTED (hidden) outside the
// epilogue so its height is measurable before the transition starts — the
// graph's slide-down target needs it on the very first frame. It fades/rises
// on the same quick duration + easing as the graph's slide, and, being a
// plain CSS transition on a stable element, plays smoothly in reverse when
// the reader scrolls back up (visibility flips only after the fade so the
// hidden panel drops out of the tab order).
export const EpilogueParcel = () => {
  const { epilogue } = useHudContext()
  const { parcelDate } = useHudDates()
  // Live-tunable epilogue timing (see the studio's "Epilogue animation"
  // section): same move duration + easing as the graph's slide.
  const { epilogueGraphMoveMs, epilogueMoveEasing } = useAnimationTuning()
  const visible = epilogue.isEpilogueHudMode
  return (
    <div
      ref={epilogue.spaceParcelRef}
      className="absolute bottom-0 w-full"
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0px)" : `translateY(${PARCEL_ENTER_RISE_PX}px)`,
        visibility: visible ? undefined : "hidden",
        pointerEvents: visible ? undefined : "none",
        transition: [
          `opacity ${epilogueGraphMoveMs}ms ${epilogueMoveEasing}`,
          `transform ${epilogueGraphMoveMs}ms ${epilogueMoveEasing}`,
          `visibility 0s ${visible ? "0s" : `${epilogueGraphMoveMs}ms`}`,
        ].join(", "),
      }}
    >
      <SpaceParcelOwnership currentDate={parcelDate} />
    </div>
  )
}
